module.exports = function () {
  $.fn.notification = function(action, options) {
    $(this).each(function(index, item) {
      var $notification = $(item),
      $close = $notification.find('.notification__content__close');

      var openAction = function() {
        $notification.addClass('notification--active');
      };

      var closeAction = function() {
        $notification.removeClass('notification--active');

        if (options && options.callbacks && options.callbacks.close) {
          options.callbacks.close();
        }
      };

      if (action === 'open') {
        openAction();
      }
      if (action === 'close') {
        closeAction();
      }

      $close.off('click').on('click', function() {
        closeAction();
      });
    });
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./source/js/notification.js
 ** module id = 6
 ** module chunks = 0
 **/